/**
 * @generated SignedSource<<3511a14a024583b420268c440263ac04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DuplicateOption_node$data = {
  readonly __typename: string;
  readonly content?: {
    readonly __typename: "Form";
    readonly id: string;
    readonly questions: ReadonlyArray<{
      readonly definition: {
        readonly __typename: string;
        readonly id: string;
        readonly maxValue?: number;
        readonly minValue?: number;
        readonly options?: ReadonlyArray<{
          readonly text: string;
          readonly value: string;
        }>;
      } | null;
      readonly id: string;
      readonly required: boolean;
      readonly text: string;
    }>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly id?: string;
  readonly name?: string;
  readonly parent?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id?: string;
      } | null;
    }>;
  };
  readonly " $fragmentType": "DuplicateOption_node";
};
export type DuplicateOption_node$key = {
  readonly " $data"?: DuplicateOption_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"DuplicateOption_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomField__FieldOption",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DuplicateOption_node",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "parent",
          "args": [
            {
              "kind": "Literal",
              "name": "depth",
              "value": 1
            }
          ],
          "concreteType": "FolderNodeConnection",
          "kind": "LinkedField",
          "name": "ancestors",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FolderNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v1/*: any*/)
                      ],
                      "type": "Folder",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "ancestors(depth:1)"
        }
      ],
      "type": "FolderNodeInterface",
      "abstractKey": "__isFolderNodeInterface"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormQuestion",
                  "kind": "LinkedField",
                  "name": "questions",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "required",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "definition",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": (v3/*: any*/),
                          "type": "CustomField__Checkboxes",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "maxValue",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "minValue",
                              "storageKey": null
                            }
                          ],
                          "type": "CustomField__Numeric",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": (v3/*: any*/),
                          "type": "CustomField__MultipleChoice",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "Form",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "FolderItem",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "268f848db5ce5a5142757d73d3fd42f5";

export default node;
